import ArmsRum from "@arms/rum-browser";

const patchFetchForFrozenOptions = () => {
  if (typeof window.fetch !== "function") return;
  const armsFetch = window.fetch;
  if (armsFetch.__frozenOptionsPatched) return;

  const patchedFetch = function(input, options) {
    if (
      options &&
      typeof options === "object" &&
      !Object.isExtensible(options)
    ) {
      options = { ...options };
    }
    return armsFetch.call(this, input, options);
  };

  patchedFetch.__frozenOptionsPatched = true;
  window.fetch = patchedFetch;
};

console.log(process.env.NODE_ENV, "process.env.NODE_ENV");
if (process.env.NODE_ENV == "production") {
  console.log("init ArmsRum");
  ArmsRum.init({
    endpoint:
      "https://proj-xtrace-b082effd2b1772d89bf79335384ea38-ap-southeast-1.ap-southeast-1.log.aliyuncs.com/rum/web/v2?workspace=default-cms-5499861294075883-ap-southeast-1&service_id=1i5jdeca5t7@259c49eb0e746a945b20d",
    env: "prod",
    spaMode: "hash",
    collectors: {
      perf: true,
      webVitals: true,
      api: true,
      staticResource: true,
      jsError: true,
      consoleError: true,
      action: true
    },
    tracing: false,
    filters: {
      exception: ["ChunkLoadError", "SyntaxError"]
    }
  });
  patchFetchForFrozenOptions();
}
